import { Injectable } from '@angular/core';
import { MessageToastRef, MessageToastService} from '@fundamental-ngx/core';
import { SessionExpiryComponent } from '../../../../core/dialog/session-expiry/session-expiry.component';
import { DialogService } from '../dialog/dialog.service';
import { ServiceModule } from '../../../service.module';
import {firstValueFrom} from "rxjs";

@Injectable({ providedIn: ServiceModule })
export class NotificationsService {
    private MESSAGE_TOAST_DURATION = 5000;
    private isSessionExpiryDialogOpen = false;
    toast: MessageToastRef;
    constructor(private messageToastService: MessageToastService, private dialogService: DialogService) {}

    public showMessageToast(text: string) {
        if(this.toast && this.toast.data === text) {
            this.toast.dismiss();
        }
        this.toast = this.messageToastService.open(text, {
            duration: this.MESSAGE_TOAST_DURATION,
            maxWidth: 'min-content',
            minWidth: '14rem',
            minHeight: 'max-content',
            mousePersist: true,
            data: text
        });

    }

    public async showSessionExpiryDialog() {
        if (this.isSessionExpiryDialogOpen) { 
            return;
        }
        try {
            const dialog = this.dialogService.openDialog(SessionExpiryComponent, {});
            this.isSessionExpiryDialogOpen = true;
            await firstValueFrom(dialog.afterClosed);
        } finally {
            this.isSessionExpiryDialogOpen = false;
        }
    }
}
